import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const NeedField = styled.div`
  background-color: ${themes.colors.background};
  border: 2px solid ${themes.colors.border};
  border-radius: 8px;
  padding: 10px;
  font-weight: bold;
  color: #878787;
  margin: 0 auto;
  @media ${device.desktop} {
    margin-top: 10px;
  }
`;

export const SmallDescription = styled.p`
  display: block;
  font-size: ${themes.textSize.s2};
  margin-top: 7px;
  margin-bottom: 7px;
  @media ${device.desktop} {
    font-size: ${themes.textSize.s3};
  }
`;
